import useScreenSize from "../../../hooks/useScreenSize";
import { Container } from "../../common/Container/Container";
import { Header } from "./components/Header";
import { LessonInfo } from "./components/LessonInfo";
import { LessonNavigation } from "./components/LessonNavigation";
import { SyllabusRightColumn } from "./components/SyllabusRightColumn";
import { TabContainer } from "./components/TabContainer";
import { TabContent } from "./components/TabContent";
import { useLearning, useLearningInit } from "./hooks/useLearning";
import { useLearningMessageInit } from "./hooks/useLearningMessage";

import "./learning.scss";

export function Learning() {
	const { width } = useScreenSize();
	const isDesktop = width > 992;
	const { loading } = useLearning();
	useLearningInit();
	useLearningMessageInit();

	return (
		<Container className="learning-container" loading={loading} noFooter>
			<div className="main-column">
				<Header />
				<LessonInfo />
				<LessonNavigation />
				<TabContainer />
				<TabContent />
			</div>
			{isDesktop && (
				<div className="right-column">
					<SyllabusRightColumn />
				</div>
			)}
		</Container>
	);
}
